import React from 'react'

const DHL = (props) => {
    return (
        <div>
            <svg
                id="prefixDHL__Warstwa_1"
                x={0}
                y={0}
                viewBox="0 0 360 200"
                xmlSpace="preserve"
                {...props}
            >
                <style>
                    {
                        ".prefixDHL__st0{fill:#ccc}.prefixDHL__st1{fill:#222}.prefixDHL__st2{fill:#e6e6e6}.prefixDHL__st10,.prefixDHL__st11{stroke-miterlimit:10}.prefixDHL__st10{fill:#d39437;stroke:#000;stroke-width:2.5;stroke-linejoin:round}.prefixDHL__st11{fill:none;stroke:#d50029;stroke-width:3}"
                    }
                </style>
                <path d="M275.3 160.7c0 15.9 12.9 28.9 28.9 28.9 15.9 0 28.9-12.9 28.9-28.9h-57.8z" />
                <path
                    className="prefixDHL__st0"
                    d="M325.3 160.7c0 11.7-9.5 21.2-21.2 21.2s-21.2-9.5-21.2-21.2h42.4z"
                />
                <path d="M312.2 160.7c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1h16.2z" />
                <path
                    className="prefixDHL__st1"
                    d="M333 160.7h-7.7c0-11.7-9.5-21.2-21.2-21.2S283 149 283 160.7h-7.7c0-15.9 12.9-28.9 28.9-28.9 15.9.1 28.8 13 28.8 28.9z"
                />
                <path
                    className="prefixDHL__st2"
                    d="M325.3 160.7h-13.1c0-4.5-3.6-8.1-8.1-8.1s-8.1 3.6-8.1 8.1h-13c0-11.7 9.5-21.2 21.2-21.2s21.1 9.5 21.1 21.2z"
                />
                <path
                    className="prefixDHL__st1"
                    d="M312.2 160.7H296c0-4.5 3.6-8.1 8.1-8.1 4.5.1 8.1 3.7 8.1 8.1z"
                />
                <path d="M41.2 160.7c0 15.9 12.9 28.9 28.9 28.9S99 176.7 99 160.7H41.2z" />
                <path
                    className="prefixDHL__st0"
                    d="M91.2 160.7c0 11.7-9.5 21.2-21.2 21.2s-21.2-9.5-21.2-21.2h42.4z"
                />
                <path d="M78.1 160.7c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1h16.2z" />
                <path
                    className="prefixDHL__st1"
                    d="M98.9 160.7h-7.7c0-11.7-9.5-21.2-21.2-21.2s-21.2 9.5-21.2 21.2h-7.7c0-15.9 12.9-28.9 28.9-28.9s28.9 13 28.9 28.9z"
                />
                <path
                    className="prefixDHL__st2"
                    d="M91.2 160.7H78.1c0-4.5-3.6-8.1-8.1-8.1s-8.1 3.6-8.1 8.1h-13c0-11.7 9.5-21.2 21.2-21.2s21.1 9.5 21.1 21.2z"
                />
                <path
                    className="prefixDHL__st1"
                    d="M78.1 160.7H62c0-4.5 3.6-8.1 8.1-8.1s8 3.7 8 8.1z"
                />
                <path
                    d="M359 148.4v.9c0 3.3-2.6 5.9-5.7 5.9H5.7c-3.2 0-5.7-2.6-5.7-5.9v-.9c0-3.3 2.6-5.9 5.7-5.9h35.4v-33.4H110v33.4h161.7v-28.8h62.9v28.8h18.6c3.2 0 5.8 2.7 5.8 5.9z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="#393534"
                />
                <g
                    stroke="#000"
                    strokeWidth={8}
                    strokeLinecap="round"
                    strokeMiterlimit={10}
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        fill="#ffe0bd"
                        d="M277.4 65.2L268 80.3"
                    />
                    <path fill="none" d="M277.4 80.3l-7-3.8" />
                </g>
                <path
                    d="M272.7 26.4h-51.2c-3.7 0-6.7 3-6.7 6.7v40.5c0 3.7 3 6.7 6.7 6.7h51.2c3.7 0 6.7-3 6.7-6.7V33c-.1-3.6-3-6.6-6.7-6.6z"
                    fill="none"
                    stroke="#000"
                    strokeMiterlimit={10}
                />
                <path
                    d="M354.5 100l-31.1-14.6c-1.9-.9-3.3-2.5-4-4.5L294.9 5.1c-1-3.1-3.9-5.2-7.2-5.2H10.5c-4.2 0-7.6 3.4-7.6 7.6v127.7c0 4.2 3.4 7.6 7.6 7.6h28.7c2.5 0 4.9-1.3 6.3-3.4 5.7-8.4 15.2-13.9 26.1-13.9 12.3 0 22.9 7 28.1 17.3h-.1l3.5 9.3a7.6 7.6 0 007.1 4.9H266c3.1 0 5.9-1.9 7.1-4.8l4.3-10.9h0c5.4-9.4 15.6-15.7 27.3-15.7 10.4 0 19.5 5 25.3 12.7 1.4 1.9 4.2 4.6 6.6 4.6H350c4.2 0 8.8-4.9 8.8-9.1V107c0-3.1-1.7-5.8-4.3-7zm-75.2-26.5c0 3.7-3 6.7-6.7 6.7h-51.2c-3.7 0-6.7-3-6.7-6.7V33c0-3.7 3-6.7 6.7-6.7h51.2c3.7 0 6.7 3 6.7 6.7v40.5zm6.2 6.6V26.8h6.5c6.9 0 7.7 6.1 7.7 6.1l14.2 47.2h-28.4z"
                    fill="#fecc00"
                    stroke="#000"
                    strokeMiterlimit={10}
                />
                <path
                    d="M230.8 87.6v-3.5l-14.6.8s-1 .2-1 1 1.2.8 1.2.8l14.4.9z"
                    stroke="#000"
                    strokeWidth={0.5}
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                />
                <path
                    d="M358.6 105.5s-3.1-1.2-3.1 1.9v18s3.1 3.8 3.1 1.5v-21.4z"
                    fill="#fff"
                    stroke="#000"
                    strokeWidth={2}
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                />
                <circle className="prefixDHL__st10" cx={352.7} cy={119.7} r={2.9} />
                <g>
                    <path
                        className="prefixDHL__st11"
                        d="M283.2 30v93.9h-3.9c-5.8 7-12.1 26.1-12.1 26.1h-56.9V28.8c0-3.5 2.8-6.3 6.3-6.3h59.2c4 0 7.4 3.4 7.4 7.5zM210.2 150h-98.7s-6.3-32.8-40.5-33.2-36.5 21.9-36.5 21.9"
                    />
                    <path className="prefixDHL__st11" d="M35.4 137.6H9V14.7s-.4-5.2-6.1-6.1" />
                </g>
                <path
                    d="M3.1 105.5s3.1-1.2 3.1 1.9v18s-3.1 3.8-3.1 1.5v-21.4z"
                    fill="#c4000d"
                    stroke="#000"
                    strokeWidth={0.75}
                    strokeLinejoin="round"
                    strokeMiterlimit={10}
                />
                <circle className="prefixDHL__st10" cx={9.2} cy={119.9} r={2.9} />
                <g>
                    <path fill="#fecc00" d="M201.6 36.2v38.3H28.1V36.2h173.5z" />
                    <path
                        d="M84 52.2c-.8 1-2 2.8-2.8 3.9-.4.5-1.1 1.5 1.2 1.5h12.4s2-2.7 3.7-5c2.3-3.1.2-9.5-7.9-9.5h-32L53 50.6h30.2c1.6 0 1.6.6.8 1.6zm-9.1 7.2c-2.3 0-1.6-1-1.2-1.5.8-1 2.1-2.8 2.8-3.8.7-1 .8-1.6-.8-1.6H61.9L50.8 67.6H78c9 0 14-6.1 15.5-8.2H74.9zm17.7 8.2h15.9l6-8.2H98.6l-6 8.2zM133.7 43l-6.1 8.3h-7.1l6.1-8.3h-15.9L100 57.5h39L149.6 43h-15.9zm-18.1 24.6h15.9l6-8.2h-15.9c.1 0-6 8.2-6 8.2zm-87.5-5v1.7h22.2l1.3-1.7H28.1zm25.8-3.2H28.1v1.7h24.6l1.2-1.7zm-25.8 8.2h19.8l1.3-1.7H28.1v1.7zm150.1-3.2h23.4v-1.7h-22.1l-1.3 1.7zm-2.4 3.2h25.7v-1.7H177l-1.2 1.7zm6.1-8.2l-1.3 1.7h21v-1.7h-19.7zM161 57.5L171.7 43h-16.9l-10.7 14.5H161zm-18.2 1.9s-1.2 1.6-1.7 2.4c-2 2.7-.2 5.9 6.3 5.9H173l6-8.2-36.2-.1z"
                        fill="#d50029"
                    />
                </g>
                <g>
                    <path d="M275.5 157.1c0 15.9 12.9 28.8 28.8 28.8s28.8-12.9 28.8-28.8h-57.6z" />
                    <path
                        className="prefixDHL__st0"
                        d="M325.4 157.1c0 11.7-9.5 21.1-21.1 21.1-11.7 0-21.1-9.5-21.1-21.1h42.2z"
                    />
                    <path d="M312.3 157.1c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1h16.2z" />
                </g>
                <g>
                    <path
                        className="prefixDHL__st1"
                        d="M333.1 157.1h-7.7c0-11.7-9.5-21.1-21.1-21.1-11.7 0-21.1 9.5-21.1 21.1h-7.7c0-15.9 12.9-28.8 28.8-28.8s28.8 12.9 28.8 28.8z"
                    />
                    <path
                        className="prefixDHL__st2"
                        d="M325.4 157.1h-13.1c0-4.5-3.6-8.1-8.1-8.1s-8.1 3.6-8.1 8.1H283c0-11.7 9.5-21.1 21.1-21.1 11.9 0 21.3 9.4 21.3 21.1z"
                    />
                    <path
                        className="prefixDHL__st1"
                        d="M312.3 157.1h-16.1c0-4.5 3.6-8.1 8.1-8.1s8 3.7 8 8.1z"
                    />
                </g>
                <g>
                    <path d="M42 157.1c0 15.9 12.9 28.8 28.8 28.8s28.8-12.9 28.8-28.8H42z" />
                    <path
                        className="prefixDHL__st0"
                        d="M92 157.1c0 11.7-9.5 21.1-21.1 21.1s-21.1-9.5-21.1-21.1H92z"
                    />
                    <path d="M78.9 157.1c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1h16.2z" />
                </g>
                <g>
                    <path
                        className="prefixDHL__st1"
                        d="M99.6 157.1H92c0-11.7-9.5-21.1-21.1-21.1s-21.1 9.5-21.1 21.1H42c0-15.9 12.9-28.8 28.8-28.8s28.8 12.9 28.8 28.8z"
                    />
                    <path
                        className="prefixDHL__st2"
                        d="M92 157.1H78.9c0-4.5-3.6-8.1-8.1-8.1s-8.1 3.6-8.1 8.1h-13c0-11.7 9.5-21.1 21.1-21.1S92 145.4 92 157.1z"
                    />
                    <path
                        className="prefixDHL__st1"
                        d="M78.9 157.1H62.8c0-4.5 3.6-8.1 8.1-8.1 4.4 0 8 3.7 8 8.1z"
                    />
                </g>
            </svg>
        </div>
    )
}

export default DHL
